import { combineReducers } from 'redux';
import list from './list';
import print from './print';
import liveDoc from './liveDocument';

export default combineReducers({
  list, print, liveDoc,
});
